function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#3D88D2",
  fillRule: "evenodd",
  d: "M6.5 7C4.096 7 3.3 5.232 3.3 3.3 3.3 1.365 4.567 0 6.5 0c1.933 0 3.2 1.366 3.2 3.3C9.7 5.231 8.904 7 6.5 7zM1.103 9.288L4.852 8l1.625 1.667L8.125 8l3.771 1.29A1.63 1.63 0 0113 10.833V11a1 1 0 01-1 1H1a1 1 0 01-1-1v-.167c0-.698.443-1.319 1.103-1.545z"
});

function SvgUserIcon(props) {
  return React.createElement("svg", _extends({
    width: 13,
    height: 12
  }, props), _ref);
}

export default SvgUserIcon;